// extracted by mini-css-extract-plugin
module.exports = {"CustomImage":"CustomImage_CustomImage__hVjy_","round":"CustomImage_round__wSYqL","bgWhite":"CustomImage_bgWhite__3Llhp","bgGray":"CustomImage_bgGray__MBnz2"};